exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__Clamp__root,\n.DS__Clamp__text {\n  all: initial;\n  font-family: var(--font-family);\n}\n\n.DS__Clamp__root {\n  all: unset;\n  display: inline-block;\n  flex-grow: 1;\n  overflow: hidden;\n}\n\n.DS__Clamp__text {\n  all: unset;\n  display: inline-block;\n  /* stylelint-disable-next-line declaration-block-no-duplicate-properties */\n  display: -webkit-box;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-box-orient: vertical;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__Clamp__root",
	"text": "DS__Clamp__text"
};